import { render, staticRenderFns } from "./historialEntregas.vue?vue&type=template&id=2139adca"
import script from "./historialEntregas.vue?vue&type=script&lang=js"
export * from "./historialEntregas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports